import React from 'react';
import { List, Grid } from 'semantic-ui-react';
import { MenuCategoryPropType } from '../../../../../../services/proptypes';
import { MenuConsumer } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import ItemContainer from '../../item/ItemContainer';
import CategoryHeader from '../components/CategoryHeader/CategoryHeader';
import '../Category.css';
var defaultProps = {
  scheduleCategories: []
};
var CategoryHorizontalCardRows = function CategoryHorizontalCardRows(_ref) {
  var category = _ref.category,
    scheduleCategories = _ref.scheduleCategories;
  return /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref2) {
    var items = _ref2.items;
    var itemIds = category.items,
      name = category.name;
    var categoryItems = MenuUtil.getCategoryItems(itemIds, items);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: '2.5rem'
      },
      id: name,
      className: "category-container"
    }, /*#__PURE__*/React.createElement(CategoryHeader, {
      category: category,
      scheduleCategories: scheduleCategories
    }), /*#__PURE__*/React.createElement(Grid, {
      className: "fcfm-chcr-container",
      stackable: true
    }, categoryItems.map(function (_ref3) {
      var _id = _ref3._id;
      return /*#__PURE__*/React.createElement(Grid.Column, {
        width: 8,
        key: _id
      }, /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(ItemContainer, {
        itemId: _id
      })));
    })));
  });
};
CategoryHorizontalCardRows.defaultProps = defaultProps;
export default CategoryHorizontalCardRows;